import React from 'react';
import { Container, Typography, Box, Link, Paper } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const TermsOfService = () => {
    const effectiveDate = 'January 6, 2026';

    return (
        <Box sx={{
            minHeight: '100vh',
            background: '#0a0e17',
            py: 6
        }}>
            <Container maxWidth="md">
                <Link
                    component={RouterLink}
                    to="/"
                    sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 1,
                        color: '#94a3b8',
                        textDecoration: 'none',
                        mb: 4,
                        '&:hover': { color: '#fff' }
                    }}
                >
                    <ArrowBackIcon fontSize="small" />
                    Back to GammaFlow
                </Link>

                <Paper sx={{
                    p: { xs: 3, md: 5 },
                    background: 'rgba(30, 41, 59, 0.7)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255, 255, 255, 0.08)',
                    borderRadius: 2
                }}>
                    <Typography variant="h4" sx={{ fontWeight: 700, color: '#fff', mb: 1 }}>
                        Terms of Service
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#64748b', mb: 4 }}>
                        Effective Date: {effectiveDate}
                    </Typography>

                    <Box sx={{ color: '#cbd5e1', '& h6': { color: '#fff', mt: 4, mb: 2, fontWeight: 600 }, '& p': { mb: 2, lineHeight: 1.7 } }}>
                        <Typography variant="h6">1. Acceptance of Terms</Typography>
                        <Typography>
                            By accessing or using GammaFlow ("the Service"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the Service.
                        </Typography>

                        <Typography variant="h6">2. Description of Service</Typography>
                        <Typography>
                            GammaFlow provides options market data visualization tools, including gamma exposure (GEX) heatmaps, key level analysis, and related analytics. The Service is designed for educational and informational purposes only.
                        </Typography>

                        <Typography variant="h6">3. Not Financial Advice</Typography>
                        <Typography sx={{ fontWeight: 600, color: '#fbbf24' }}>
                            THE INFORMATION PROVIDED BY GAMMAFLOW DOES NOT CONSTITUTE FINANCIAL, INVESTMENT, TRADING, OR OTHER ADVICE. You should not treat any of the Service's content as such. GammaFlow does not recommend that any securities, strategies, or investments are suitable for you.
                        </Typography>
                        <Typography>
                            Any investment decisions you make are solely your responsibility. Always consult with a qualified financial advisor before making investment decisions.
                        </Typography>

                        <Typography variant="h6">4. User Accounts</Typography>
                        <Typography>
                            Access to GammaFlow requires authentication through Whop. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
                        </Typography>

                        <Typography variant="h6">5. Subscription and Payments</Typography>
                        <Typography>
                            GammaFlow subscriptions are managed through Whop. Billing, refunds, and subscription management are subject to Whop's terms and policies.
                        </Typography>

                        <Typography variant="h6">6. Intellectual Property</Typography>
                        <Typography>
                            All content, features, and functionality of the Service are owned by GammaFlow and are protected by international copyright, trademark, and other intellectual property laws. You may not reproduce, distribute, or create derivative works without our express written permission.
                        </Typography>

                        <Typography variant="h6">7. Limitation of Liability</Typography>
                        <Typography>
                            TO THE MAXIMUM EXTENT PERMITTED BY LAW, GAMMAFLOW SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO LOSS OF PROFITS, DATA, OR OTHER INTANGIBLE LOSSES RESULTING FROM YOUR USE OF THE SERVICE.
                        </Typography>

                        <Typography variant="h6">8. Disclaimer of Warranties</Typography>
                        <Typography>
                            THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. We do not guarantee the accuracy, completeness, or timeliness of any data or information provided through the Service.
                        </Typography>

                        <Typography variant="h6">9. Data Accuracy</Typography>
                        <Typography>
                            While we strive to provide accurate market data, GammaFlow relies on third-party data providers. We make no guarantees regarding the accuracy, reliability, or completeness of this data. Always verify information with official sources before making any decisions.
                        </Typography>

                        <Typography variant="h6">10. Termination</Typography>
                        <Typography>
                            We reserve the right to suspend or terminate your access to the Service at any time, with or without cause, and with or without notice.
                        </Typography>

                        <Typography variant="h6">11. Changes to Terms</Typography>
                        <Typography>
                            We may modify these Terms at any time. Continued use of the Service after changes constitutes acceptance of the modified Terms.
                        </Typography>

                        <Typography variant="h6">12. Governing Law</Typography>
                        <Typography>
                            These Terms shall be governed by and construed in accordance with the laws of the United States, without regard to its conflict of law provisions.
                        </Typography>

                        <Typography variant="h6">13. Contact</Typography>
                        <Typography>
                            For questions about these Terms, please contact us through our Whop page or support channels.
                        </Typography>
                    </Box>
                </Paper>
            </Container>
        </Box>
    );
};

export default TermsOfService;
